import { render } from "./templateSelect.vue?vue&type=template&id=63b91ed4&scoped=true"
import script from "./templateSelect.vue?vue&type=script&lang=js"
export * from "./templateSelect.vue?vue&type=script&lang=js"

import "./templateSelect.vue?vue&type=style&index=0&id=63b91ed4&lang=less&scoped=true"
import "./templateSelect.vue?vue&type=style&index=1&id=63b91ed4&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b91ed4"]])

export default __exports__